import React from "react"
import Svg from "../../_svgs/svg"

export default function MerchantItem({
  link,
  cssClass,
  handleClickElement,
  splashLabel,
  ribbonColor,
  isRibbonValid,
  image,
  name,
  shopLocation,
  alwaysOpen,
  alwaysOpenLabel,
  openingHoursForTheDay,
  closingHoursForTheDay,
  opening,
  lastItemRef,
  itineraryComponent,
  isShown = true,
}) {
  const isDeactivated = ribbonColor == "theme-mandarin" && isRibbonValid ? true : false

  return (
    <a
      ref={lastItemRef}
      href={link}
      className={`${cssClass}${isDeactivated ? " deactivated" : ""}`}
      onClick={handleClickElement ? (e) => handleClickElement(e) : undefined}
      tabIndex={isShown === false ? "-1" : isDeactivated ? "-1" : "0"}
    >
      <div className={`slide-inner`}>
        {(splashLabel && ribbonColor && isRibbonValid) || (itineraryComponent && splashLabel) ? (
          <div className={`splash ${ribbonColor ?? ""}`}>{splashLabel}</div>
        ) : undefined}
        <div className="img-container">
          <img src={image} />
        </div>
        <div className="imgtext">
          <div className="merchant">{name}</div>
          {shopLocation ? (
            <div className="atgate">
              <Svg iconName={"markerpin"} />
              {shopLocation}
            </div>
          ) : null}

          {alwaysOpen ? (
            <div className="openinghours">
              <Svg iconName={"clock3"} />
              {alwaysOpenLabel}
            </div>
          ) : opening ? (
            <div className="openinghours">
              <Svg iconName={"clock3"} />
              {opening}
            </div>
          ) : openingHoursForTheDay && closingHoursForTheDay ? (
            <div className="openinghours">
              <Svg iconName={"clock3"} />
              {openingHoursForTheDay} - {closingHoursForTheDay}
            </div>
          ) : null}
        </div>
      </div>
    </a>
  )
}
